import { render } from "./landingPage.vue?vue&type=template&id=391a7e62"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=391a7e62&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__